<mat-spinner *ngIf="loading" class="page-spinner" diameter="100" color="accent"></mat-spinner>
  <h1 class="card-title text-center mb-4 mt-2">Assign Bill</h1>
  <form [formGroup]="mainForm" (ngSubmit)="onSubmit()" novalidate>
    <mat-form-field class="w-100 mt-3"
    style="padding-left: 3%; padding-right: 3%; margin-top: 3%;">
    <mat-label>
      <mat-icon style="margin-right: 5px;">receipt_long</mat-icon>Bills</mat-label>
    <input matInput placeholder="Search Bills" [(ngModel)]="selectedBill" [ngModelOptions]="{standalone: true}"
      [matAutocomplete]="auto" required (input)="filterBill($event)" id="trip_3">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onBillSelected($event)">
      <mat-option *ngFor="let bill of filteredBills" [value]="bill.name">
        {{ bill.name }}
      </mat-option>
    </mat-autocomplete>
</mat-form-field>
<div class="text-center mt-5 mb-2">
    <a mat-raised-button class="btn-link ms-2" style="padding-right: 10px;" id="cancel_register"
      (click)="onNoClick()">Cancel</a>
    <button mat-raised-button [disabled]="!selectedBill" class="custom-button" id="orgRegisterButton1">
      Assign Bill
    </button>
  </div>
</form>
